// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"643":"cebb36ed7837cea8","915":"6ea22ce4e9f876f6"}[chunkId] + ".js";
};